export default __webpack_public_path__ + "static/media/otp-code.43227dc9.jpg";